/*
Copyright 2025 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const TranscriptIcon = ({
  width = 24,
  height = 24,
  hidden = false,
  title = 'Transcript',
} = {}): string | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    width="${width}"
    height="${height}"
    viewBox="0 0 20 20"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <path
      d="M1.75,16.65234c-.41406,0-.75-.33594-.75-.75v-6.5c0-.41406.33594-.75.75-.75s.75.33594.75.75v6.5c0,.41406-.33594.75-.75.75Z"
      fill="currentColor"
      stroke-width="0"
    />
    <path
      d="M4.75,19c-.41406,0-.75-.33594-.75-.75V6.75c0-.41406.33594-.75.75-.75s.75.33594.75.75v11.5c0,.41406-.33594.75-.75.75Z"
      fill="currentColor"
      stroke-width="0"
    />
    <path
      d="M7.75,15.65234c-.41406,0-.75-.33594-.75-.75v-4.5c0-.41406.33594-.75.75-.75s.75.33594.75.75v4.5c0,.41406-.33594.75-.75.75Z"
      fill="currentColor"
      stroke-width="0"
    />
    <path
      d="M16.75,18h-5.5c-.41406,0-.75-.33594-.75-.75s.33594-.75.75-.75h5.5c.41309,0,.75-.33691.75-.75V3.25c0-.41309-.33691-.75-.75-.75H7.25c-.41309,0-.75.33691-.75.75v.47949c0,.41406-.33594.75-.75.75s-.75-.33594-.75-.75v-.47949c0-1.24023,1.00977-2.25,2.25-2.25h9.5c1.24023,0,2.25,1.00977,2.25,2.25v12.5c0,1.24023-1.00977,2.25-2.25,2.25Z"
      fill="currentColor"
      stroke-width="0"
    />
    <path
      d="M15,6.5h-6c-.41406,0-.75-.33594-.75-.75s.33594-.75.75-.75h6c.41406,0,.75.33594.75.75s-.33594.75-.75.75Z"
      fill="currentColor"
      stroke-width="0"
    />
    <path
      d="M15,10.5h-3.75c-.41406,0-.75-.33594-.75-.75s.33594-.75.75-.75h3.75c.41406,0,.75.33594.75.75s-.33594.75-.75.75Z"
      fill="currentColor"
      stroke-width="0"
    />
    <path
      d="M15,14.5h-3.75c-.41406,0-.75-.33594-.75-.75s.33594-.75.75-.75h3.75c.41406,0,.75.33594.75.75s-.33594.75-.75.75Z"
      fill="currentColor"
      stroke-width="0"
    />
  </svg>`;
};
